import { Component, DestroyRef, OnDestroy, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatLabel } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatError } from '@angular/material/form-field';
import { SelfOnboardCustomerRequest } from '../../customer.model';
import { CommonModule } from '@angular/common';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

export type SelfOnboardCustomerFormType = FormGroup<{
  customerEmail: FormControl<string | null>,
  customerAccountNumber: FormControl<string | null>,
}>;

@Component({
  selector: 'app-self-onboard-customer-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatLabel,
    MatInputModule,
    MatError,
    CommonModule
  ],
  providers: [
    provideNgxMask()
  ],
  templateUrl: './self-onboard-customer-form.component.html',
  host: { class: 'app-self-onboard-customer-form' }
})
export class SelfOnboardCustomerFormComponent implements OnInit, OnDestroy {
  errorMessages = {
    customerAccountNumber: {
      required: 'Account number is required',
      pattern: 'Account number can only contain letters, numbers, and hyphens'
    },
    customerEmail: {
      required: 'Email is required',
      //email: 'Please enter a valid email address',
      pattern: 'Please enter a valid email address'
    },
  };

  @Input() data: any; // temporarily use any to handle the modal wrapper

  form: SelfOnboardCustomerFormType = new FormGroup({
    customerAccountNumber: new FormControl({ value: '', disabled: false }, [
      Validators.required,
      Validators.pattern(/^[A-Za-z0-9-]+$/)
    ]),
    customerEmail: new FormControl('', [
      Validators.required,
      //Validators.email,
      Validators.pattern(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)
    ]),
  });

  constructor(
    protected destroyRef: DestroyRef
  ) {
  }

  ngOnInit(): void {
    console.log('Component initializing with data:', this.data);
    
    // Extract the actual data from the modal configuration
    const formData = this.data?.data as SelfOnboardCustomerRequest;
    
    setTimeout(() => {
      if (formData?.type === 'customerflashupdate' || formData?.type === 'paymentflashupdate') {
        console.log('Attempting to patch form with:', {
          customerEmail: formData.customerEmail,
          customerAccountNumber: formData.customerAccountNumber,
        });
        
        this.form.patchValue({
          customerEmail: formData.customerEmail || '',
          customerAccountNumber: formData.customerAccountNumber || '',
        });

        // Disable the account number field for flash updates
        this.form.get('customerAccountNumber')?.disable();
        
      }
    });
  }

  ngOnDestroy(): void {
  }
}